import Swiper, {Navigation, Pagination} from 'swiper';

export default function swiper() {

    new Swiper('.block-licenses .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.block-licenses .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-licenses .swiper-button-next',
            prevEl: '.block-licenses .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-gallery .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        pagination: {
            el: '.block-gallery .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-gallery .swiper-button-next',
            prevEl: '.block-gallery .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })


    // shortcodes

    new Swiper('.block-shortcode-reviews .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        autoHeight: false,
        loop: true,
        pagination: {
            el: '.block-shortcode-reviews .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-shortcode-reviews .swiper-button-next',
            prevEl: '.block-shortcode-reviews .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1000: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-shortcode-licenses .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        autoHeight: false,
        loop: true,
        pagination: {
            el: '.block-shortcode-licenses .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-shortcode-licenses .swiper-button-next',
            prevEl: '.block-shortcode-licenses .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-shortcode-wards-slide .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        autoHeight: false,
        loop: true,
        pagination: {
            el: '.block-shortcode-wards-slide .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-shortcode-wards-slide .swiper-button-next',
            prevEl: '.block-shortcode-wards-slide .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1000: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-doctors-shortcode .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.block-doctors-shortcode .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-doctors-shortcode .swiper-button-next',
            prevEl: '.block-doctors-shortcode .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 2,
            },
        },
        modules: [Navigation, Pagination]
    })
}
